import React, { Fragment } from 'react';
import { Button } from '@xingternal/button';

import { Page } from '../../../../models/page';
import { Version, VersionStatus } from '../../../../models/version';

export type TransitionButtonProps = {
  page: Page;
  version: Version;
  onPublish: () => void;
  onRevert: () => void;
  onCloneVersion: () => void;
  dirtyForm: boolean;
  submitting: boolean;
};

export const TransitionButton = ({
  page,
  version,
  onPublish,
  onRevert,
  onCloneVersion,
  dirtyForm,
  submitting,
}: TransitionButtonProps): React.ReactElement => {
  return (
    <Fragment>
      {page.clonable && (
        <Button
          id="cloneBtn"
          data-cy="clone-btn"
          onClick={onCloneVersion}
          size="large"
          type="button"
          variant="secondary"
        >
          Clone
        </Button>
      )}
      {version.status === VersionStatus.draft && (
        <Button
          size="large"
          id="publishBtn"
          data-cy="publish-btn"
          disabled={dirtyForm}
          loading={submitting}
          variant="secondary"
          type="button"
          onClick={(): void => {
            (!dirtyForm ||
              confirm(
                'Changes were made but not saved. Are you sure you want to publish the version?'
              )) &&
              onPublish();
          }}
        >
          Publish
        </Button>
      )}
      {version.status === VersionStatus.scheduled && (
        <Button
          id="backToDraftBtn"
          data-cy="back-to-draft-btn"
          loading={submitting}
          size="large"
          type="button"
          variant="secondary"
          onClick={onRevert}
        >
          Back to draft
        </Button>
      )}
    </Fragment>
  );
};
